import { gql } from '@apollo/client';

const GET_USER_LICENSE_BY_USER_ID = gql`
  query GetUserLicenseByUserId($externalUserId: Int!) {
    userLicense(externalUserId: $externalUserId) {
      ExternalUserId
      FirstName
      LastName
      Email
      SystemRole {
        Id
        DisplayName
      }
      SupplementalRoleId
      LicensedOrgId
      LicensedOrgUnitId
      AllowedOrgIds
      AllowedOrgUnitIds
      AllowedOhtIds
      IsSuperUser
      IsAppraiser
      IsDeactivated
      CanAccessInvoices
    }
  }
`;

export default GET_USER_LICENSE_BY_USER_ID;
